/*! sticky-sidebar - v3.3.1 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.StickySidebar={})}(this,function(t){"use strict";"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var e,i,n=(function(t,e){(function(t){Object.defineProperty(t,"__esModule",{value:!0});var l,n,e=function(){function n(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(t,e,i){return e&&n(t.prototype,e),i&&n(t,i),t}}(),i=(l=".stickySidebar",n={topSpacing:0,bottomSpacing:0,containerSelector:!1,innerWrapperSelector:".inner-wrapper-sticky",stickyClass:"is-affixed",resizeSensor:!0,minWidth:!1},function(){function c(t){var e=this,i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),this.options=c.extend(n,i),this.sidebar="string"==typeof t?document.querySelector(t):t,void 0===this.sidebar)throw new Error("There is no specific sidebar element.");this.sidebarInner=!1,this.container=this.sidebar.parentElement,this.affixedType="STATIC",this.direction="down",this.support={transform:!1,transform3d:!1},this._initialized=!1,this._reStyle=!1,this._breakpoint=!1,this.dimensions={translateY:0,maxTranslateY:0,topSpacing:0,lastTopSpacing:0,bottomSpacing:0,lastBottomSpacing:0,sidebarHeight:0,sidebarWidth:0,containerTop:0,containerHeight:0,viewportHeight:0,viewportTop:0,lastViewportTop:0},["handleEvent"].forEach(function(t){e[t]=e[t].bind(e)}),this.initialize()}return e(c,[{key:"initialize",value:function(){var i=this;if(this._setSupportFeatures(),this.options.innerWrapperSelector&&(this.sidebarInner=this.sidebar.querySelector(this.options.innerWrapperSelector),null===this.sidebarInner&&(this.sidebarInner=!1)),!this.sidebarInner){var t=document.createElement("div");for(t.setAttribute("class","inner-wrapper-sticky"),this.sidebar.appendChild(t);this.sidebar.firstChild!=t;)t.appendChild(this.sidebar.firstChild);this.sidebarInner=this.sidebar.querySelector(".inner-wrapper-sticky")}if(this.options.containerSelector){var e=document.querySelectorAll(this.options.containerSelector);if((e=Array.prototype.slice.call(e)).forEach(function(t,e){t.contains(i.sidebar)&&(i.container=t)}),!e.length)throw new Error("The container does not contains on the sidebar.")}"function"!=typeof this.options.topSpacing&&(this.options.topSpacing=parseInt(this.options.topSpacing)||0),"function"!=typeof this.options.bottomSpacing&&(this.options.bottomSpacing=parseInt(this.options.bottomSpacing)||0),this._widthBreakpoint(),this.calcDimensions(),this.stickyPosition(),this.bindEvents(),this._initialized=!0}},{key:"bindEvents",value:function(){window.addEventListener("resize",this,{passive:!0,capture:!1}),window.addEventListener("scroll",this,{passive:!0,capture:!1}),this.sidebar.addEventListener("update"+l,this),this.options.resizeSensor&&"undefined"!=typeof ResizeSensor&&(new ResizeSensor(this.sidebarInner,this.handleEvent),new ResizeSensor(this.container,this.handleEvent))}},{key:"handleEvent",value:function(t){this.updateSticky(t)}},{key:"calcDimensions",value:function(){if(!this._breakpoint){var t=this.dimensions;t.containerTop=c.offsetRelative(this.container).top,t.containerHeight=this.container.clientHeight,t.containerBottom=t.containerTop+t.containerHeight,t.sidebarHeight=this.sidebarInner.offsetHeight,t.sidebarWidth=this.sidebarInner.offsetWidth,t.viewportHeight=window.innerHeight,t.maxTranslateY=t.containerHeight-t.sidebarHeight,this._calcDimensionsWithScroll()}}},{key:"_calcDimensionsWithScroll",value:function(){var t=this.dimensions;t.sidebarLeft=c.offsetRelative(this.sidebar).left,t.viewportTop=document.documentElement.scrollTop||document.body.scrollTop,t.viewportBottom=t.viewportTop+t.viewportHeight,t.viewportLeft=document.documentElement.scrollLeft||document.body.scrollLeft,t.topSpacing=this.options.topSpacing,t.bottomSpacing=this.options.bottomSpacing,"function"==typeof t.topSpacing&&(t.topSpacing=parseInt(t.topSpacing(this.sidebar))||0),"function"==typeof t.bottomSpacing&&(t.bottomSpacing=parseInt(t.bottomSpacing(this.sidebar))||0),"VIEWPORT-TOP"===this.affixedType?t.topSpacing<t.lastTopSpacing&&(t.translateY+=t.lastTopSpacing-t.topSpacing,this._reStyle=!0):"VIEWPORT-BOTTOM"===this.affixedType&&t.bottomSpacing<t.lastBottomSpacing&&(t.translateY+=t.lastBottomSpacing-t.bottomSpacing,this._reStyle=!0),t.lastTopSpacing=t.topSpacing,t.lastBottomSpacing=t.bottomSpacing}},{key:"isSidebarFitsViewport",value:function(){var t=this.dimensions,e="down"===this.scrollDirection?t.lastBottomSpacing:t.lastTopSpacing;return this.dimensions.sidebarHeight+e<this.dimensions.viewportHeight}},{key:"observeScrollDir",value:function(){var t=this.dimensions;if(t.lastViewportTop!==t.viewportTop){var e="down"===this.direction?Math.min:Math.max;t.viewportTop===e(t.viewportTop,t.lastViewportTop)&&(this.direction="down"===this.direction?"up":"down")}}},{key:"getAffixType",value:function(){this._calcDimensionsWithScroll();var t=this.dimensions,e=t.viewportTop+t.topSpacing,i=this.affixedType;return e<=t.containerTop||t.containerHeight<=t.sidebarHeight?(t.translateY=0,i="STATIC"):i="up"===this.direction?this._getAffixTypeScrollingUp():this._getAffixTypeScrollingDown(),t.translateY=Math.max(0,t.translateY),t.translateY=Math.min(t.containerHeight,t.translateY),t.translateY=Math.round(t.translateY),t.lastViewportTop=t.viewportTop,i}},{key:"_getAffixTypeScrollingDown",value:function(){var t=this.dimensions,e=t.sidebarHeight+t.containerTop,i=t.viewportTop+t.topSpacing,n=t.viewportBottom-t.bottomSpacing,o=this.affixedType;return this.isSidebarFitsViewport()?t.sidebarHeight+i>=t.containerBottom?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):i>=t.containerTop&&(t.translateY=i-t.containerTop,o="VIEWPORT-TOP"):t.containerBottom<=n?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):e+t.translateY<=n?(t.translateY=n-e,o="VIEWPORT-BOTTOM"):t.containerTop+t.translateY<=i&&0!==t.translateY&&t.maxTranslateY!==t.translateY&&(o="VIEWPORT-UNBOTTOM"),o}},{key:"_getAffixTypeScrollingUp",value:function(){var t=this.dimensions,e=t.sidebarHeight+t.containerTop,i=t.viewportTop+t.topSpacing,n=t.viewportBottom-t.bottomSpacing,o=this.affixedType;return i<=t.translateY+t.containerTop?(t.translateY=i-t.containerTop,o="VIEWPORT-TOP"):t.containerBottom<=n?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):this.isSidebarFitsViewport()||t.containerTop<=i&&0!==t.translateY&&t.maxTranslateY!==t.translateY&&(o="VIEWPORT-UNBOTTOM"),o}},{key:"_getStyle",value:function(t){if(void 0!==t){var e={inner:{},outer:{}},i=this.dimensions;switch(t){case"VIEWPORT-TOP":e.inner={position:"fixed",top:i.topSpacing,left:i.sidebarLeft-i.viewportLeft,width:i.sidebarWidth};break;case"VIEWPORT-BOTTOM":e.inner={position:"fixed",top:"auto",left:i.sidebarLeft,bottom:i.bottomSpacing,width:i.sidebarWidth};break;case"CONTAINER-BOTTOM":case"VIEWPORT-UNBOTTOM":var n=this._getTranslate(0,i.translateY+"px");e.inner=n?{transform:n}:{position:"absolute",top:i.translateY,width:i.sidebarWidth}}switch(t){case"VIEWPORT-TOP":case"VIEWPORT-BOTTOM":case"VIEWPORT-UNBOTTOM":case"CONTAINER-BOTTOM":e.outer={height:i.sidebarHeight,position:"relative"}}return e.outer=c.extend({height:"",position:""},e.outer),e.inner=c.extend({position:"relative",top:"",left:"",bottom:"",width:"",transform:""},e.inner),e}}},{key:"stickyPosition",value:function(t){if(!this._breakpoint){t=this._reStyle||t||!1,this.options.topSpacing,this.options.bottomSpacing;var e=this.getAffixType(),i=this._getStyle(e);if((this.affixedType!=e||t)&&e){var n="affix."+e.toLowerCase().replace("viewport-","")+l;for(var o in c.eventTrigger(this.sidebar,n),"STATIC"===e?c.removeClass(this.sidebar,this.options.stickyClass):c.addClass(this.sidebar,this.options.stickyClass),i.outer){var s="number"==typeof i.outer[o]?"px":"";this.sidebar.style[o]=i.outer[o]+s}for(var r in i.inner){var a="number"==typeof i.inner[r]?"px":"";this.sidebarInner.style[r]=i.inner[r]+a}var p="affixed."+e.toLowerCase().replace("viewport-","")+l;c.eventTrigger(this.sidebar,p)}else this._initialized&&(this.sidebarInner.style.left=i.inner.left);this.affixedType=e}}},{key:"_widthBreakpoint",value:function(){window.innerWidth<=this.options.minWidth?(this._breakpoint=!0,this.affixedType="STATIC",this.sidebar.removeAttribute("style"),c.removeClass(this.sidebar,this.options.stickyClass),this.sidebarInner.removeAttribute("style")):this._breakpoint=!1}},{key:"updateSticky",value:function(){var t,e=this,i=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this._running||(this._running=!0,t=i.type,requestAnimationFrame(function(){switch(t){case"scroll":e._calcDimensionsWithScroll(),e.observeScrollDir(),e.stickyPosition();break;case"resize":default:e._widthBreakpoint(),e.calcDimensions(),e.stickyPosition(!0)}e._running=!1}))}},{key:"_setSupportFeatures",value:function(){var t=this.support;t.transform=c.supportTransform(),t.transform3d=c.supportTransform(!0)}},{key:"_getTranslate",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0,e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0,i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0;return this.support.transform3d?"translate3d("+t+", "+e+", "+i+")":!!this.support.translate&&"translate("+t+", "+e+")"}},{key:"destroy",value:function(){window.removeEventListener("resize",this,{capture:!1}),window.removeEventListener("scroll",this,{capture:!1}),this.sidebar.classList.remove(this.options.stickyClass),this.sidebar.style.minHeight="",this.sidebar.removeEventListener("update"+l,this);var t={inner:{},outer:{}};for(var e in t.inner={position:"",top:"",left:"",bottom:"",width:"",transform:""},t.outer={height:"",position:""},t.outer)this.sidebar.style[e]=t.outer[e];for(var i in t.inner)this.sidebarInner.style[i]=t.inner[i];this.options.resizeSensor&&"undefined"!=typeof ResizeSensor&&(ResizeSensor.detach(this.sidebarInner,this.handleEvent),ResizeSensor.detach(this.container,this.handleEvent))}}],[{key:"supportTransform",value:function(t){var i=!1,e=t?"perspective":"transform",n=e.charAt(0).toUpperCase()+e.slice(1),o=document.createElement("support").style;return(e+" "+["Webkit","Moz","O","ms"].join(n+" ")+n).split(" ").forEach(function(t,e){if(void 0!==o[t])return i=t,!1}),i}},{key:"eventTrigger",value:function(t,e,i){try{var n=new CustomEvent(e,{detail:i})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,i)}t.dispatchEvent(n)}},{key:"extend",value:function(t,e){var i={};for(var n in t)void 0!==e[n]?i[n]=e[n]:i[n]=t[n];return i}},{key:"offsetRelative",value:function(t){var e={left:0,top:0};do{var i=t.offsetTop,n=t.offsetLeft;isNaN(i)||(e.top+=i),isNaN(n)||(e.left+=n),t="BODY"===t.tagName?t.parentElement:t.offsetParent}while(t);return e}},{key:"addClass",value:function(t,e){c.hasClass(t,e)||(t.classList?t.classList.add(e):t.className+=" "+e)}},{key:"removeClass",value:function(t,e){c.hasClass(t,e)&&(t.classList?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\b)"+e.split(" ").join("|")+"(\\b|$)","gi")," "))}},{key:"hasClass",value:function(t,e){return t.classList?t.classList.contains(e):new RegExp("(^| )"+e+"( |$)","gi").test(t.className)}},{key:"defaults",get:function(){return n}}]),c}());t.default=i,window.StickySidebar=i})(e)}(e={exports:{}},e.exports),e.exports),o=(i=n)&&i.__esModule&&Object.prototype.hasOwnProperty.call(i,"default")?i.default:i;t.default=o,t.__moduleExports=n,Object.defineProperty(t,"__esModule",{value:!0})});

window.oaFilterException = true;

if(window.oaAlgoliaFilter){           
  window.oaFilterException = false;
}

window.oaStickySidebar = (function () {
  var selectorSticky = '.fixed-filter-box',
      selectorStickyInner = '.fixed-filter-box .sticky-filter',
      selectorStickyContainer = '.oa-shop-collection-box',
      selectorStickyDesktop = '.oa-shop-filter.oa-shop-filter__divider',
      selector = '.oa-shop-selected-filters-container';

  var sidebar;

  function isFilterVisible() {
  var el = document.querySelector(selectorStickyDesktop);
  if (!el) return false;
  return window.getComputedStyle(el).display !== 'none';
}

  function setupResizeDetector() {
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function (entries) {
        window.oaStickySidebar.handleSizeChanged();
      });
      ro.observe(document.querySelector(selectorStickyInner));
      ro.observe(document.querySelector(selectorStickyContainer));
      ro.observe(document.querySelectorAll(selector));
    } else {
      Array.prototype.slice.call(document.querySelectorAll('.oa-shop-filter__sub-heading[onclick]')).forEach(function (el) {
        el.addEventListener('click', function () {
          setTimeout(window.oaStickySidebar.handleSizeChanged, 200);
        }, { passive: true });
      });
    }
  }

  function setup() {
    if (isMobile() || !isFilterVisible()) {
      return;
    }

    var el = document.querySelector(selectorSticky);
    var elHeader = document.getElementById('oa-hdr19');

    if (!el || !elHeader) {
      return;
    } 

    sidebar = new StickySidebar(el, { 
      containerSelector: selectorStickyContainer,
      topSpacing: elHeader.offsetHeight || 0,
      resizeSensor: false 
    });

    setupResizeDetector();
  }

  function handleSizeChanged() {
    if (!sidebar) {
      return;
    }
    sidebar.updateSticky();
  }

  return {
    setup: setup,
    handleSizeChanged: handleSizeChanged
  };
})();

window.oaShopFilter = (function () {

  var containerSelector = '.oa_shop_collection';
  var headerTopSelector = '.oa-hdr19-top';
  var shopBannerTitleSelector = '.oa-shop-banner h4[data-filter-title]';
  var collectionHandle = window.location.pathname.replace(/\/collections\//, '')
  //Array of keyword to filters
  //Every new filter keyword gets pushed to the array when clicked active
  var filter = [];
  var filterString = '';
  var urlState = '';
  var collectionPath = '/collections/';

  var mf = Shopify.money_format.replace(/\{\{ amount[_,a-z]* \}\}/, '{{amount_no_decimals}}');
  var filterContainer = $('.oa-shop-selected-filters-container');
  var activeWearFilterListSelector = '.oa-shop-filter__list';

  var mainFilterClass = $(".mainFilterClass");
  var collisionPartnerMain = $("#oa-shop-filter__main");
  var collisionPartnerSub = $(".oa-shop-filter--desktop");

  var mainFilterAll = $('.oa-shop-filter [data-all="all"]');
  var filterCount = $('.filter-options-count');

  var categoryFilters = [];
  var activeFilterListElements;
  var displayActiveFilters = false;

  var shop_lang = window.location.pathname.split('/')[0] !== '' && window.location.pathname.split('/')[0] !== 'de' && window.location.pathname.split('/')[0] !== 'fr' ? window.location.pathname.split('/')[0].toUpperCase() : 'EN'

  var color_translation={
    EN:{black:'Black',blue:'Blue', brown:'Brown', green:'Green', grey:'Gray', pink:'Pink', purple:'Purple', red:'Red', orange: 'Orange', yellow:'Yellow', white:'White'},
    DE:{black:'Schwarz ',blue:'Blau ', brown:'Braun', green:'Grün', grey:'Grau', pink:'Rosa', purple:'Violett', red:'Rot', orange: 'Orange', yellow:'Gelb', white:'Weiß'},
    FR:{black:'Noir',blue:'Blue', brown:'Marron', green:'Vert', grey:'Gris', pink:'Rose', purple:'Violet', red:'Rouge', orange: 'Orange', yellow:'Yellow', white:'Blanc'},
    ME:{black:'Black',blue:'Blue', brown:'Brown', green:'Green', grey:'Gray', pink:'Pink', purple:'Purple', red:'Red', orange: 'Orange', yellow:'Yellow', white:'White'},
  };
  var fashion_sizes = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
  var discount_values_fashion = ['20off', '30off', '40off', '50off', '60off', '70off','spring-clearance'];
  var discount_values_fashion_sale = ['spring-sale-bestseller', 'spring-sale-leggings', 'spring-sale-shorts', 'spring-sale-coats', 'spring-sale-tops','spring-sale-hoodies', 'spring-sale-joggers', 'spring-sale-underwear','spring-sale-accessories'];
  var discount_values_fashion_other = ['classic-capsule', 'krissys-style-edit','last-chance','outlet', 'buy-3-save-15', 'black-friday', 'focus-capsule', 'everybody-capsule', 'raw-lounge-capsule', 'spring-sale', 'spring-sale-bestseller', 'new', 'best-seller', 'one-more-rep', 'mia-green', 'active-rest-day', 'accentuate', 'brenda-anton', 'hybrid-launch', 'strong-yet-soft', 'pause-and-recharge', 'always-in-oner', 'set-the-tone', 'strong-is-a-statement', 'outlet'];
  var discount_values_fashion_gains = ['day-1', 'day-2', 'day-3', 'day-4', 'day-5', 'day-6','day-7', 'day-8', 'day-9', 'day-10', 'day-11', 'day-12'];
  var discount_values_fitness = ['20-30off', '30-40off', '40-50off', '50-60off', '60-70off'];
  var discount_translation={
    EN:{discount:'Discount'},
    DE:{discount:'Rabatt'},
    FR:{discount:'de réduction'},
    ME:{discount:'Discount'},
  };
  var discount_translation_gains={
    EN:{day:'Day'},
    DE:{day:'Tag'},
  };

  var urlStatePath = window.location.pathname.split('/').filter(function (p) { return p.length > 0; }).pop();

  if(collectionHandle.indexOf('/en') > -1 && window.location.host == 'me.oneractive.com'){
    collectionHandle = collectionHandle.replace('/en','').split(/\//).shift();
    collectionPath = '/en/collections/';
  }else{
    collectionHandle = collectionHandle.split(/\//).shift();
  }
  if (urlStatePath != collectionHandle) {
    urlState = urlStatePath; 
  } else {
    mainFilterAll.addClass('checked');
  }

var priceFilter = (function () {

    
    var sliders = document.querySelectorAll(".range-slider input[type='range']");
    var thumbs = document.querySelectorAll(".range-slider .thumb");
    var range = document.querySelectorAll(".range-slider .range");
    var rangeValues = document.querySelectorAll(".rangeValues");
    var priceRmin = null;
    var priceRmax = null;
    var priceRangeIndex = null;
    var children = null;

    function isInitialized() {
      return sliders && sliders.length > 0;
    }

    function isPriceInRange(item) {
      return item.dataset.price >= priceRmin && item.dataset.price <= priceRmax;
    }

    function isActive () {
      // for (let i = 0; i < sliders.length; i += 2) {
      //   if (!((priceRmin/100) == sliders[i].min && (priceRmax/100) == sliders[i+1].max)) {
      //     return true;
      //   }
      // }
      // return false;
      let i = priceRangeIndex - (priceRangeIndex % 2); // ensure even index (start of pair)
      return !((priceRmin/100) == sliders[i].min && (priceRmax/100) == sliders[i + 1].max);
    }

    function setMinMax(min, max){
      priceRmin = min;
      priceRmax = max;
    }

    function setPriceRangeText() {
      rangeValues = document.querySelectorAll(".rangeValues");
      rangeValues.forEach(function(el) {
        el.innerHTML = getPriceValuesText();
      });
    }

    function getPriceValuesText() {
      var min = Shopify.formatMoney(priceRmin, mf);
      var max = Shopify.formatMoney(priceRmax, mf);
      var text = "<div>" + min + "</div>" + "<div> – </div>" + "<div>" + max + "</div>";
      return text.replace(/\s/g, '&nbsp;');
    }

    function getPriceRangeValues() {
      let slide1, slide2, tL, tR;
      // Use the current priceRangeIndex to determine which slider pair to use
      let pair = priceRangeIndex !== null && priceRangeIndex !== undefined ? Math.floor(priceRangeIndex / 2) : 0;
      let minIndex = pair * 2;
      let maxIndex = minIndex + 1;

      slide1 = parseFloat(sliders[minIndex].value * 100);
      slide2 = parseFloat(sliders[maxIndex].value * 100);
      tL = thumbs[minIndex].style.left;
      tR = thumbs[maxIndex].style.left;

      if (slide1 > slide2) {
      // Swap values and thumb positions if needed
      [slide1, slide2] = [slide2, slide1];
      [tL, tR] = [tR, tL];
      }

      // Update range bar style for all pairs
      for (let i = 0; i < range.length; i++) {
      let left = parseInt(tL);
      let right = parseInt(tR);
      range[i].style.left = left + '%';
      range[i].style.width = Math.abs(right - left) + '%';
      }

      setMinMax(slide1, slide2);
      setPriceRangeText();
      return [slide1, slide2];
    }
    function resetPriceRangeValues(noRangeAndThumbs) {
      setMinMax(null, null);
      if (noRangeAndThumbs !== true) {
        sliders[0].value = sliders[0].min;
        sliders[1].value = sliders[1].max;
        sliders[2].value = sliders[2].min;
        sliders[3].value = sliders[3].max;
        sliders[4].value = sliders[4].min;
        sliders[5].value = sliders[5].max;

        range[0].style.left = '0%';
        range[1].style.left = '0%';
        range[2].style.left = '0%';
        range[0].style.width = '100%';
        range[1].style.width = '100%';
        range[2].style.width = '100%';

        thumbs[0].style.left = '0%';
        thumbs[2].style.left = '0%';
        thumbs[4].style.left = '0%';
        thumbs[1].style.left = '100%';
        thumbs[3].style.left = '100%';
        thumbs[5].style.left = '100%';
      }
      getPriceRangeValues();
      setPriceRangeText();
       document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter: oaShopFilter.getFilter(), filtermin: 99999, filtermax: 99999 } }));
    }

    function handlePriceSlider(el) {
      if(!el) {return;}
      var ctx = el;
      sliders.forEach(function (s, index) {
        priceRangeIndex = index;
        if (ctx === sliders[priceRangeIndex]) {
          if (index < 2) {
            sliders[2].value = sliders[0].value;
            sliders[3].value = sliders[1].value;
            sliders[4].value = sliders[0].value;
            sliders[5].value = sliders[1].value;
          } else if (index < 4) {
            sliders[0].value = sliders[2].value;
            sliders[1].value = sliders[3].value;
            sliders[4].value = sliders[2].value;
            sliders[5].value = sliders[3].value;
          } else {
            sliders[0].value = sliders[4].value;
            sliders[1].value = sliders[5].value;
            sliders[2].value = sliders[4].value;
            sliders[3].value = sliders[5].value;
          }

          var value = (100 / (parseInt(ctx.max) - parseInt(ctx.min))) * parseInt(ctx.value) - (100 / (parseInt(ctx.max) - parseInt(ctx.min))) * parseInt(ctx.min);
          children = ctx.parentNode.childNodes[1].childNodes;
          if (index == 0 || index == 2 || index == 4) {
            thumbs[0].style.left = value + '%';
            thumbs[2].style.left = value + '%';
            thumbs[4].style.left = value + '%';
            range[0].style.left = value + '%';
            range[1].style.left = value + '%';
            range[2].style.left = value + '%';
            range[0].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
            range[1].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
            range[2].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
          } else {
            thumbs[1].style.left = value + '%';
            thumbs[3].style.left = value + '%';
            thumbs[5].style.left = value + '%';
            range[0].style.left = thumbs[2].style.left;
            range[1].style.left = thumbs[2].style.left;
            range[2].style.left = thumbs[2].style.left;
            range[0].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
            range[1].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
            range[2].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
          }
          return;
        }
      });
      getPriceRangeValues();
    }

    function init() {
      if (!isInitialized()) { return; }
      handlePriceSlider();
    }

    function getSliders() {
      return sliders;
    }

    return {
      init: init,
      isInitialized: isInitialized,
      isPriceInRange: isPriceInRange,
      isActive: isActive,
      handlePriceSlider: handlePriceSlider,
      getPriceValuesText: getPriceValuesText,
      resetPriceRangeValues: resetPriceRangeValues,
      getSliders: getSliders,
      getPriceRangeValues: getPriceRangeValues,
    };
  })();

  function animatedScrollTop() {
    return;
    var body = $('html, body');
    var collection = document.querySelector(containerSelector);
    var scrollTop = 0;
    if (collection !== null) {
      scrollTop = collection.offsetTop; 
    }
    var headerTop = document.querySelector(headerTopSelector);
    if (headerTop !== null) {
      /*if(window.screen.width < 1300) {
        scrollTop = 400;
      } else {
        scrollTop = Math.max(0, scrollTop - headerTop.clientHeight);
      }*/
      scrollTop = Math.max(0, scrollTop - headerTop.clientHeight);
    }
    if (window.scrollY < 100) {
      scrollTop = 0; 
    }
    setTimeout(function() {
      body.stop().animate({ scrollTop:scrollTop }, '225'); //800
    }, 100);
  }


  function initCategoryFilter(categories) {

    if (categories && categories.length > 0) {
      categoryFilters = categories;
    }
  }

  function isFilterListEmpty () {
    return activeFilterListElements.every(el => el.querySelectorAll('li').length < 1);
  }

  function isCategoryInFilter(cf) {
    return filter.some(function(v) { 
      cf.includes(v);
    });
  }

  function getShopLang () {
    var l = window.location.host.split('.')[0];
    if(l === 'de') {
      return l.toUpperCase();
    } else if (l === 'fr') {
      return l.toUpperCase();
    } else if (l === 'me'){
      if(window.location.pathname.includes('/en/')) {
        return 'EN';
      } else {
        return 'AR';
      }
    } else {
      return 'EN';
    }
  }

  function appendLi(categoryFilter, f, li, checkbox, text) {
    var removeIcon = document.createElement("div");
    removeIcon.className = "remove-icon";
    removeIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M0.901769 0.458065C0.67065 0.690323 0.487114 0.903226 0.500709 0.935484C0.514305 0.96129 1.42518 1.87742 2.5264 2.96774C3.62761 4.05806 4.53849 4.96774 4.55209 4.99355C4.55889 5.01935 3.68879 5.90323 2.61477 6.96774C1.53395 8.02581 0.616269 8.94839 0.561888 9.01935C0.480317 9.13548 0.507507 9.18065 0.922162 9.56774L1.3708 10L1.71748 9.67742C1.90782 9.49677 2.83229 8.59355 3.77036 7.65806L5.47656 5.96129L6.8021 7.27097C7.52944 7.99355 8.46072 8.89677 8.86177 9.29032L9.58912 10L10.0378 9.58065C10.2825 9.35484 10.4796 9.14194 10.4796 9.10968C10.4796 9.05806 10.0038 8.58065 7.6382 6.23871L6.38744 5L7.66539 3.72258C8.36555 3.02581 9.29002 2.11613 9.71827 1.69677L10.5 0.948387L10.2893 0.696774C10.1805 0.561291 9.96979 0.348388 9.83383 0.225806L9.58912 0L9.16767 0.419355C8.93655 0.651613 8.01207 1.55484 7.12159 2.43871L5.49016 4.03871L5.0891 3.66452C4.87158 3.45806 3.9539 2.55484 3.05661 1.65806C2.15253 0.767742 1.3912 0.032258 1.36401 0.032258C1.34361 0.032258 1.13289 0.225806 0.901769 0.458065Z" fill="black"/>
    </svg>`;
    li.appendChild(removeIcon);

    let found = false;
    activeFilterListElements.forEach(function (listEl) {
      const items = listEl.querySelectorAll('li[data-id="' + f + '"]');
      if (items.length > 0) {
        found = true;
        items[0].addEventListener("click", function (event) {
          event.preventDefault();
          checkbox.click();
          li.remove();
          if (isFilterListEmpty()) {
            filterContainer.addClass("hidden");
            if (isCategoryInFilter(categoryFilter)) {
              mainFilterAll.addClass("checked");
            }
          }
        });
      }
    });
    if (found) {
      console.log("Filter already exists in active filter list:", f);
      return;
    }

    // TODO: If this is changed, categories are also displayed, but the logix for the active filter.
    // if (categoryFilter.indexOf(f) == -1) {
    if (f !== 'all') {
      if (text) {
        li.appendChild(
          document.createTextNode(text.replace(/ *\([^)]*\) */g, ""))
        );
      } else {
        li.appendChild(
          document.createTextNode(color_translation[getShopLang()][f])
        );
      }

      li.setAttribute("data-id", f);
      li.addEventListener("click", function (event) {
        event.preventDefault();
        checkbox.click();
        li.remove();
        if (isFilterListEmpty()) {
          filterContainer.addClass("hidden");
          if (isCategoryInFilter(categoryFilter)) {
            mainFilterAll.addClass("checked");
          }
        }
      });

      activeFilterListElements.forEach(function (listEl) {
        listEl.appendChild(li.cloneNode(true));
      });
      if (filterContainer.hasClass("hidden")) {
        filterContainer.removeClass("hidden");
      }
    }
  }

  function addFilterToList(f) {
    if (!displayActiveFilters) {
      return;
    }
    if (f === '*' || !f) {

      return; 
    }
    if (displayActiveFilters && !activeFilterListElements) {
      activeFilterListElements = Array.from(document.querySelectorAll(activeWearFilterListSelector));
    }


    var checkbox = $('.oa-shop-collection-box .oa-shop-filter .oa-shop-filter__wrapper label[data-id="'+f+'"]').first();
    var text = checkbox.text();
    categoryTitle = checkbox.closest('.oa-shop-filter__wrapper').find('.oa-shop-filter__sub-heading').text();
    var li = document.createElement('li');
    // if(fashion_sizes.includes(f)) { text = f.toUpperCase(); }
    if(discount_values_fashion.includes(f)) { 
      text = f.replace('off', '% '+discount_translation[getShopLang()]['discount']); 
    } //ToDo translation

    const offValues = [
      10,
      20,
      30,
      40,
      50,
      60,
    ];
    for (let offValue of offValues) {
      if (text.includes(offValue+'%') || f.includes(offValue+'off')) {
        if (getShopLang() === 'EN') {
          text = `up to ${offValue}% off`;
        } else {
          text = `bis zu -${offValue}%`;
        }
      }  
    }

    if (discount_values_fashion_other.indexOf(f) !== -1) {
      switch (f) {
        case 'black-friday':
          text = 'Black Friday';
          break;
        case 'classic-capsule':
          text = 'Classic Capsule';
          break;
        case 'krissys-style-edit':
          text = "Krissy's Style Edit";
          break;
      }
    }    

    var selectedFilterTitle = '';
    if (isMobile()) {
      selectedFilterTitle = text;
    } else {
      selectedFilterTitle = categoryTitle + ': ' + text;
    }

    appendLi(categoryFilters, f, li, checkbox, selectedFilterTitle);

  }

  function getFilteredItemCount() {
    if(!window.oaFilterException){return;}
  }

  function appendFilter(f) { 
    if (!f) {
      return;
    }
    if (filter.includes(f)) {
      return;
    }
    filter.push(f); 
    addFilterToList(f);
    return filter;
  }

  function appendFilterString(fs) { 
    if (fs) {
      filterString += fs; 
    }
    return filterString;
  }

  function getFirstFilterStringPart() {
    var parts = filterString.split('.').filter(function (part) { return part.trim().length > 0; });
    if (parts.length === 1) {
      return parts[0]; 
    }
    return null;
  }

  function updateShopBannerTitle() {
    
    var shopBannerTitle = document.querySelector(shopBannerTitleSelector);
    
    if (!shopBannerTitle) {
      return; 
    }
    var filterPart = getFirstFilterStringPart();
    if(filterPart == 'spring-clearance'){return;}
    if (filterPart) {
      var label = document.querySelector('.oa-shop-filter__checkbox[data-id="'+filterPart+'"]');
      if (label && label.hasAttribute('data-banner-title')) {
        var langFilterText = label.innerText;
        shopBannerTitle.innerHTML = langFilterText;
      }
    } else {
      shopBannerTitle.innerHTML = shopBannerTitle.getAttribute('data-initial-content');
    }
  }

  function countItems(){ 
    var filteredItems = getFilteredItemCount();
    if(window.oaAlgoliaFilter){ 
      // $('.filter-result-count').text('('+oaShopFilter.getFilter().length+')');
      //$('.filter-result-count-desk').text(oaShopFilter.getFilter().length);
    }else{
    $('.filter-result-count').text('('+filteredItems+')');
    $('.filter-result-count-desk').text(filteredItems);
    }
    window.oaShopFilter.updateOptionsCount();
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      $('.oa-filter-sidebar-wrapper .oa-side-filter-footer').css('bottom','50px;');
    }
  }

  function removeFilter(key){
    var index = filter.indexOf(key);
    if (index > -1) {
      filter.splice(index, 1);
    }

    if (key === 'pricerange') {
      priceFilter.resetPriceRangeValues();
    }

    if (key === 'selected-sort') {
      window.oaShopSort.resetSortFilter();
    }
  
    if(isFilterListEmpty()) {
      filterContainer.addClass('hidden');
      if(isCategoryInFilter(categoryFilters)) {
        mainFilterAll.addClass('checked');
      }
    }
  }

  function isChecked($this){
    if ($this.hasClass('checked')) {
      return true;
    } else {
      return false
    }
  }

  function setFilter(f) { 
    filter = [];
    for (var i = 0; i < f.length; i++) {
      appendFilter(f[i]); 
    }
  }

  var shopBannerCache = {};

  function updateShopFitnessBanner(category) {
    if (!category) { category = ''; }
    var oldBanner = document.querySelector('.oa-content > .container.container--shop');
    if (!oldBanner) { return; }
    if (shopBannerCache[category]) {
      $(oldBanner).replaceWith(shopBannerCache[category]);
      updateShopBannerTitle();
      return; 
    }
    axios.get('/collections/shop-fitness/' + category + '?view=fitness-ajax-banner').then(function(response) {
      shopBannerCache[category] = response.data;
      $(oldBanner).replaceWith(response.data);
      updateShopBannerTitle();
    });
  }

  function getFilteredItemsWithouPrice() {
    var filters = window.oaShopFilter.getFilter();
  }

  function updateMinMaxPriceFromFilteredItems() {
    return;

    var minPrice;
    var maxPrice;
    getFilteredItemsWithouPrice().forEach(function (item) {
      var price = parseInt(item.element.dataset.price);
      if (isNaN(price)) {
        return;
      }
      price = price / 100;
      if (typeof minPrice === 'undefined') {
        minPrice = Math.floor(price);
      }
      if (typeof maxPrice === 'undefined') {
        maxPrice = Math.ceil(price); 
      }
      if (price < minPrice) {
        minPrice = Math.floor(price);
      }
      if (price > maxPrice) {
        maxPrice = Math.ceil(price); 
      }
    });
    setPriceMinMaxValues(minPrice, maxPrice);
  }


  function filterCallback () {
    countItems();
    updateShopBannerTitle();
    updateMinMaxPriceFromFilteredItems();
    algoliaFilterTracking('collectionFilter',filter);



    var filterPart = getFirstFilterStringPart();
    if (filterPart) {
      $('.collection-headline span.collection-head-subtext').show(); 
      if(window.location.pathname.split('/').splice(-1).indexOf('black-friday') == -1){
        let newPathname = collectionPath + collectionHandle + '/' + filterPart;
        if (window.location.pathname !== newPathname) {
          window.history.pushState(filterPart, '', newPathname);
        }
        var langFilterText = $('.oa-shop-filter__checkbox.'+filterPart).first().text();
        $('.collection-headline span.collection-head-subtext').text(langFilterText); 
      }
    } else {
      if(window.location.pathname.split('/').splice(-1).indexOf('black-friday') == -1){
        $('.collection-headline span.collection-head-subtext').hide(); 
        let newPathname = collectionPath + collectionHandle;
        if (window.location.pathname !== newPathname) {
          window.history.pushState(collectionHandle, '', newPathname);
        }
      }
    }

  
    document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter:filter}}));
  }

  function filterItems(el) {
    if(filterString) {
      return filter.every(function(f) {
        return el.classList.contains(f);
      }) && priceFilter.isPriceInRange(el);
    } else {
      return priceFilter.isPriceInRange(el);
    }
  }

  function handleCheckboxClick($checkboxes, filterValues, e) {
    var $id = $(this).attr('data-id');
    var $this = $('.oa-shop-filter .oa-shop-filter__wrapper [data-id="'+$id+'"]');
    var isAll = false;

    //Srcoll top after Filter Selection
    animatedScrollTop();

    if($this.length < 1) {
      //$this = $('.oa-shop-filter .oa-shop-filter__wrapper label[data-all]');
      isAll = true;
    }
    if ($checkboxes && filterValues) {
      if ($checkboxes.hasClass('checked')) {
        filter = jQuery.grep(filter, function(item) {
          return !filterValues.includes(item) && item;
        });
      }
    }
    //Handle the 'checked' class on the filter labels
    if (isChecked($this)) {
      $this.removeClass('checked');
      $('.oa-shop-filter__list li[data-id="'+$id+'"]').remove();
      removeFilter($id);
      $('.oa-filter-string').text('');
      if(categoryFilters.indexOf($id) != -1){
        mainFilterAll.addClass('checked');
      }
    } else {
      if ($checkboxes) {
        $checkboxes.removeClass('checked');
        $checkboxes.each(function (index, checkbox) {
          $('.oa-shop-filter__list li[data-id="'+checkbox.getAttribute('data-id')+'"]').remove();
        });
      }
      $('.oa-filter-string').text('');
      $this.addClass('checked');

      appendFilter($id);
    }

    if(isAll) {
      mainFilterAll.addClass('checked');
    }
    setTimeout(function() {
      if (filter) {
        filterString = '';
        var l = filter.length;
        filter.forEach(function(item, index) {
          appendFilterString('.' + item);
        });

        //Filter the Grid
      }
      filterCallback();

      if (isChecked($this)) {
      scrollElementIntoViewIfNeeded($id, (e && e.target.parentElement || this));
      } else if (isChecked(mainFilterAll)) {
        var mainFilterAll2 = $('#oa-shop-filter__main .oa-shop-filter [data-all="all"]');
        scrollElementIntoViewIfNeeded(mainFilterAll2.data('all') || mainFilterAll2.data('id'), mainFilterAll2.get(0));
      }
    }, 200);

    
function getFilters(input) {
    const filterSettings = window.filterSettingsFashion;

    const filters = {
        size: null,
        activity: null,
        color: null,
        category: null,
        collection: null,
        other: null
    };

    input.forEach(item => {
        if (filterSettings.size.includes(item)) {
            filters.size = item;
        } else if (filterSettings.activity.includes(item)) {
            filters.activity = item;
        } else if (filterSettings.color.includes(item)) {
            filters.color = item;
        } else if (filterSettings.collection.includes(item)) {
            filters.collection = item;
        } else if (filterSettings.other.includes(item)) {
            filters.other = item;
        } else if (filterSettings.category.includes(item)) {
            filters.category = item;
        }
    });

    return { filters };
}

   Shopify.analytics.publish("filter_applied_custom", 	getFilters(filter));
   //console.log(getFilters(filter));
    
  }

  function updatePriceMinMax(slider, min, max) {
    if (typeof slider.dataset.min === 'undefined') {
      slider.dataset.min = slider.min;
    }
    if (typeof slider.dataset.max === 'undefined') {
      slider.dataset.max = slider.max;
    }

    //     var xMin = parseInt(priceRmin/100);
    //     var xMax = parseInt(priceRmax/100);
    //     if (isPriceFilterSet()) {
    //       if (typeof min !== 'undefined' && xMin < min) {
    //         min = xMin;
    //       }
    //       if (typeof max !== 'undefined' && xMax > max) {
    //         max = xMax;
    //       }
    //     }

    slider.min = typeof min !== 'undefined' ? min : slider.dataset.min;
    slider.max = typeof max !== 'undefined' ? max : slider.dataset.max;
    if (parseInt(slider.value) < parseInt(slider.min)) {
      slider.value = slider.min; 
    } else if (parseInt(slider.value) > parseInt(slider.max)) {
      slider.value = slider.max; 
    }
  }

  function getSlideValue(slide) {
    return (100/(parseInt(slide.max)-parseInt(slide.min)))*parseInt(slide.value)-(100/(parseInt(slide.max)-parseInt(slide.min)))*parseInt(slide.min);
  }

  function updateThumbsAndRanges(min, max) {
    for (var i = 0; i < thumbs.length; i+=2) {
      var thumb1 = thumbs[i];
      var thumb2 = thumbs[i + 1];
      thumb1.style.left = min+'%';
      thumb2.style.left = max+'%';
    }
    for (var i = 0; i < range.length; i++) {
      range[i].style.left = min+'%';
      range[i].style.width = Math.abs(max-min)+'%';
    } 
  }

  function setPriceMinMaxValues(min, max) {
    if (typeof min !== 'undefined' && typeof max !== 'undefined' && sliders[0].min == min && sliders[0].max == max) {
      return; 
    }

    for (var i = 0; i < sliders.length; i+=2) {
      var slide1 = sliders[i];
      var slide2 = sliders[i + 1];
      updatePriceMinMax(slide1, min, max);
      updatePriceMinMax(slide2, min, max);
      if (parseInt(slide1.value) == parseInt(slide2.value)) {
        slide1.value = slide1.min;
        slide2.value = slide2.max;
      }
      updateThumbsAndRanges(getSlideValue(slide1), getSlideValue(slide2));
    }
    var rangeValues = document.querySelectorAll(".rangeValues");
    setPriceRangeValues(rangeValues, true);
  }

  function resetPriceRangeValues(noRangeAndThumbs) {
    var labelLi = document.querySelector(".oa-shop-filter__list li[data-pricerange]");
    if (labelLi) {
      removeFilter('pricerange');
      labelLi.remove();
    }

    priceFilter.resetPriceRangeValues(noRangeAndThumbs)
    if(isFilterListEmpty()) {
      filterContainer.addClass('hidden');
    }
  }

  function updateOptionsCount() {
    var t = filter.length;
    if(priceFilter.isActive()) {

      t += 1;
    } else {
      resetPriceRangeValues(true);
    }
    if(window.oaAlgoliaFilter){
      t = oaShopFilter.getFilter().length;
      if(window.oaAlgolia.priceRangeString != '' && window.oaAlgolia.priceRangeString != undefined){
        t = oaShopFilter.getFilter().length + 1;
      }
    }
    filterCount.text(t > 0 ? '(' + t + ')' : '');   
  }

  function handlePriceSlider(sliders, rangeValues, event){
    priceFilter.handlePriceSlider(this);
    var text = priceFilter.getPriceValuesText(); 
    var labelLi = document.querySelector(".oa-shop-filter__list li[data-pricerange]");
    if(labelLi) {
      if(!priceFilter.isActive()) {
        resetPriceRangeValues(true);
      }
    } else  {
      var li = document.createElement('li');
      li.classList.add('checked');
      li.setAttribute('data-pricerange', true);
      li.setAttribute('data-id', 'pricerange');
      var rangeValues = document.createElement('div');
      rangeValues.classList.add('rangeValues');
      rangeValues.innerHTML = text;
      li.appendChild(rangeValues);
      var removeIcon = document.createElement("div");
      removeIcon.className = "remove-icon";
      removeIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
      <path d="M0.901769 0.458065C0.67065 0.690323 0.487114 0.903226 0.500709 0.935484C0.514305 0.96129 1.42518 1.87742 2.5264 2.96774C3.62761 4.05806 4.53849 4.96774 4.55209 4.99355C4.55889 5.01935 3.68879 5.90323 2.61477 6.96774C1.53395 8.02581 0.616269 8.94839 0.561888 9.01935C0.480317 9.13548 0.507507 9.18065 0.922162 9.56774L1.3708 10L1.71748 9.67742C1.90782 9.49677 2.83229 8.59355 3.77036 7.65806L5.47656 5.96129L6.8021 7.27097C7.52944 7.99355 8.46072 8.89677 8.86177 9.29032L9.58912 10L10.0378 9.58065C10.2825 9.35484 10.4796 9.14194 10.4796 9.10968C10.4796 9.05806 10.0038 8.58065 7.6382 6.23871L6.38744 5L7.66539 3.72258C8.36555 3.02581 9.29002 2.11613 9.71827 1.69677L10.5 0.948387L10.2893 0.696774C10.1805 0.561291 9.96979 0.348388 9.83383 0.225806L9.58912 0L9.16767 0.419355C8.93655 0.651613 8.01207 1.55484 7.12159 2.43871L5.49016 4.03871L5.0891 3.66452C4.87158 3.45806 3.9539 2.55484 3.05661 1.65806C2.15253 0.767742 1.3912 0.032258 1.36401 0.032258C1.34361 0.032258 1.13289 0.225806 0.901769 0.458065Z" fill="black"/>
      </svg>`;
      li.appendChild(removeIcon);
      li.addEventListener('click', function (event) {
        event.preventDefault();
        // removeFilter('pricerange');
        resetPriceRangeValues();
      });
      if (displayActiveFilters && !activeFilterListElements) {
        activeFilterListElements = Array.from(document.querySelectorAll(activeWearFilterListSelector));
      }
      if(priceFilter.isActive()) {
        activeFilterListElements.forEach(function(listEl) {
          listEl.appendChild(li.cloneNode(true));
        });
        if(filterContainer.hasClass('hidden')){
          filterContainer.removeClass('hidden');
        }
      }
    } 
    updateOptionsCount();
  }

  function appendListItemToList(item) {
    if (displayActiveFilters && !activeFilterListElements) {
      activeFilterListElements = Array.from(document.querySelectorAll(activeWearFilterListSelector));
    }
    activeFilterListElements.forEach(function(listEl) {
      listEl.appendChild(item.cloneNode(true));
    });
    if(filterContainer.hasClass('hidden')){
      filterContainer.removeClass('hidden');
    }
  }

  jQuery(document).ready( function($){

    mf = Shopify.money_format.replace(/\{\{ amount[_,a-z]* \}\}/, '{{amount_no_decimals}}');
    sliders = document.querySelectorAll(".range-slider input[type='range']");
    thumbs = document.querySelectorAll(".range-slider .thumb");
    range = document.querySelectorAll(".range-slider .range");
    var rangeValues = document.querySelectorAll(".rangeValues");
    priceRmin = null;
    priceRmax = null;
    priceRangeIndex = null;
    children = null;

    var mobileMainFilter = document.querySelector(".oa-shop-filter__divider-category-mobile");
    
    if(priceFilter && window.oaFilterException){
      priceFilter.init();
    }

    var sliders = priceFilter.getSliders();
    sliders.forEach(function(el){
      el.addEventListener('input', handlePriceSlider.bind(el, sliders, rangeValues));
      el.addEventListener('mouseup', function() {
        animatedScrollTop();
        //Filter the Grid
        document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter: oaShopFilter.getFilter(), filtermin: priceFilter.getPriceRangeValues()[0], filtermax:priceFilter.getPriceRangeValues()[1] } }));
        filterCallback();
      });
      el.addEventListener('touchend', function() {
        animatedScrollTop();
        document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter: oaShopFilter.getFilter(), filtermin: priceFilter.getPriceRangeValues()[0], filtermax:priceFilter.getPriceRangeValues()[1] } }));
        filterCallback();
      });
    });
    if(window.oaFilterException){
      handlePriceSlider();
    }

    if(mobileMainFilter) {
      mobileMainFilter.querySelectorAll('label').forEach(function(el){
        el.addEventListener('touchstart', function(){
          el.classList.add("touched");
        });
        el.addEventListener('touchend', function(){
          el.classList.remove("touched");
        });
      });
    }

    var $p_filter_desktop_reset = $('.oa-shop-filter__delete-heading');
    var $p_filter_mobile = $('.oa-shop-tabs-mobile');

    //DELETE FILTER STRING ITEMS (MOBILE)
    $('.oa-filter-string').on('click', '.item', function(e){

      var item_id = $(this).attr('data-id');
      var item_index = filter.indexOf(item_id);

      //Srcoll top after Filter Selection
      animatedScrollTop();

      $(e.target).remove();
      filter.splice(item_index, 1);

      $('.'+item_id).removeClass('checked');

      //console.log('.'+item_id);

      filterString = "";
      var l = filter.length;

      filter.forEach(function(item,index){

        appendFilterString('.' + item);

        //add items to filter string 
        var item_string = item.match(/[^_]+$/);
      });

      filterCallback();
    });

    //Handle Reset
    $p_filter_desktop_reset.click( function(e){
      e.preventDefault();

      $('.oa-shop-filter__wrapper label').removeClass('checked');
      $('.oa-filter-string').text('');
      $('.oa-shop-filter__list').empty();
      $('.oa-shop-selected-filters-container').toggleClass('hidden');
      filterString = '';
      setFilter([]);
      resetPriceRangeValues();
      mainFilterAll.addClass('checked');


      animatedScrollTop();
      if(window.oaFilterException){
        filterCallback();
      }
    });
    $('.oa-shop-filter__list').on('click', 'li[data-id]', function(e) {
      e.preventDefault();
      var $li = $(this).closest('li');
      var $id = $li.attr('data-id');
      var $checkbox = $('.oa-shop-filter .oa-shop-filter__wrapper label[data-id="'+$id+'"]');
      $checkbox.removeClass('checked');
      $li.remove();
      $('.oa-shop-filter__list li[data-id="'+$id+'"]').remove();
      removeFilter($id);
      $('.oa-filter-string').text('');
      if (categoryFilters.indexOf($id) != -1) {
        mainFilterAll.addClass('checked');
      }

      if ($('.oa-shop-filter__list li').length === 0) {
        $('.oa-shop-filter__wrapper label').removeClass('checked');
        $('.oa-filter-string').text('');
        $('.oa-shop-filter__list').empty();
        $('.oa-shop-selected-filters-container').toggleClass('hidden');
        filterString = '';
        setFilter([]);
        resetPriceRangeValues();
        mainFilterAll.addClass('checked');
      }

      filterCallback();
    });
    $p_filter_mobile.find('li a').click( function(e){
      e.preventDefault();

      var id = $(this).attr('data-id');

      $p_filter_mobile.find('li').removeClass('active');
      $(this).parent().addClass('active');
      filterCallback();
    });

    //h1 adjustment on page load
    var filterPart = getFirstFilterStringPart();
    if (filterPart) {
      $('.collection-headline span.collection-head-subtext').show(); 
      let newPathname = collectionPath + collectionHandle + '/' + filterPart;
      if (window.location.pathname !== newPathname) {
        window.history.pushState(filterPart, '', newPathname);
      }
      var langFilterText = $('.oa-shop-filter__checkbox.'+filterPart).first().text();
      $('.collection-headline span.collection-head-subtext').text(langFilterText); 
    }

  });

  function initUrlFilter(mainFilter) {
    if (collectionHandle != 'shop' && window.oaFilterException) {
    }
    if (urlState.length === 0) {
      return;
    }
    var checkbox = $('.oa-shop-collection-box .oa-shop-filter .oa-shop-filter__wrapper label[data-id="' + urlState + '"]').first();
    if (urlState.length === 0) {
      return;
    }

    if (urlState != collectionHandle && checkbox.length !== 0) {
      if (urlState == 'all') {
      } else {
        setFilter([urlState]);
        filterString = '.' + urlState;
        window.oaShopFilter.updateShopBannerTitle();
        $('.oa-shop-filter [data-id="' + urlState + '"]').addClass('checked');
        scrollElementIntoViewIfNeeded(urlState, mainFilter);
      }
    } else {
      mainFilterAll.addClass('checked');
    }
    if (window.oaShopFilter.getFilter().length > 0) {

      if (!$('.oa-shop-filter__checkbox-category_all').hasClass('checked') && window.location.pathname.split('/').splice(-1)[0].split('+').length > 1) {
        filterCount.text(filter.length > 0 ? '(' + (filter.length + 1) + ')' : '');
      } else {
        filterCount.text(filter.length > 0 ? '(' + filter.length + ')' : '');
      }
    }
  }

    function countFilteredItems(list, filter) {
    if(list) {
      if(filter){
        list.filter(function (f) {
          return f !== filter;
        });
      }
    }
    var filters = window.oaShopFilter.getFilter().filter(function (f) { return list.indexOf(f) === -1 && f !== filter; });
  }

  function setCategoryCountResultText (list) {
    list.forEach(function(f) {
      var rText = countFilteredItems(list, f); 
      var label = $('.filter-result-'+f).closest('label');
      if(!label.hasClass('checked')) {
        if(rText == 0){
          if(!label.hasClass('hidden')) {
            label.addClass('hidden');
          }
        } else {
          if(label.hasClass('hidden')) {
            label.removeClass('hidden');
          }
        }
      }
      console.log(f);
      // $('.filter-result-'+f).text('('+ rText +')');
    });
  }

  function countCategories(list){
    var filteredItems = countFilteredItems(list);
    
    $('.filter-result-all').text('('+filteredItems+')');
    setCategoryCountResultText(list);
  }

  function collision() {
    var y1 = collisionPartnerMain.offset().top;
    var y2 = collisionPartnerSub.offset().top;
    var h2 = collisionPartnerSub.outerHeight(true) + 1;
    var b2 = y2 + h2;
    if (y1 >= (b2-h2)) return false;
    return true;
  }

  function initMainFilterClass() {
    $(window).scroll(function() {
      //var $div1 = $("#testId");
      //var $div2 = $(".oa-shop-filter--desktop");
      if(collision()) {
        mainFilterClass.removeClass("mainFilterClass--hidden");
      } else {
        if(!mainFilterClass.hasClass("mainFilterClass--hidden")) { 
          mainFilterClass.addClass("mainFilterClass--hidden");
        }
      }

    });
  }

  function scrollElementIntoViewIfNeeded(id, element) {
    if(categoryFilters.indexOf(id) != -1) {
      if (element) {
        //element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      //$('.oa-shop-filter__sub__inner-flex-mobile label[data-id="'+id+'"]').get(0).scrollIntoViewIfNeeded();
    } else {
      if (element) {
        //element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }
  
  /*function scrollElementIntoViewIfNeeded(id) {
    if(categoryFilters.indexOf(id) != -1) {
      $('.oa-shop-filter__sub__inner-flex-mobile label[data-id="'+id+'"]').get(0).scrollIntoViewIfNeeded();
    }
  }*/


  return {
    animatedScrollTop: animatedScrollTop,
    updateShopBannerTitle: updateShopBannerTitle,
    collectionHandle: collectionHandle,
    getFilter: function () { return filter; },
    setFilter: setFilter,
    appendFilter: appendFilter,
    getFilterString: function () { return filterString; },
    setFilterString: function (fs) { filterString = fs; },
    appendFilterString: appendFilterString,
    getUrlState: function () { return urlState; },
    setUrlState: function (us) { urlState = us; },
    handleCheckboxClick: handleCheckboxClick,
    filterCallback: filterCallback,
    initUrlFilter: initUrlFilter,
    enableDisplayActiveFilters: function () { displayActiveFilters = true; },
    getFilteredItemCount: getFilteredItemCount,
    initCategoryFilter: initCategoryFilter,
    handlePriceSlider: handlePriceSlider,
    updateOptionsCount: updateOptionsCount,
    appendListItemToList: appendListItemToList,
    isFilterListEmpty: isFilterListEmpty,
    isCategoryInFilter: isCategoryInFilter,
    countCategories: countCategories,
    initMainFilterClass: initMainFilterClass
  };
})();

window.oaShopSort = (function () {

  var labels,
      activeClass = 'checked';

  function uncheckLabel(label) {
    $(label).removeClass(activeClass);
  }

  function uncheckLabels() {
    if (!labels) {
      labels = $('.oa-sort-container label, .desktop-sort-by-dropdown label, .desktop-sort-by-dropdown a');
    }
    labels.each(function () {
      uncheckLabel(this);
    });
  }

  function checkPopularSort() {
    labels = $('.oa-sort-container label, .desktop-sort-by-dropdown label, .desktop-sort-by-dropdown a');
    labels.each(function () {
      var $label = $(this);
      var sortOption = $label.attr('data-sort-option');
      if (sortOption) {
        try {
          var parsed = typeof sortOption === 'string' ? JSON.parse(sortOption) : sortOption;
          if (
            parsed &&
            parsed.sortBy === 'order' &&
            parsed.sortAscending === true
          ) {
            checkLabel($label);
          }
        } catch (e) {
          // ignore parse errors
        }
      }
    });

  }

  function updateGrid(options) {

    if(!window.oaFilterException){
      if(options.sortBy == 'order'){
        options = JSON.stringify(options);
      }
      document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filterSort: JSON.parse(options) } }));
      return;
    }
    
    if (typeof options === 'string') {
      options = JSON.parse(options);
    }
  }

  function checkLabel(label) {
    label.addClass(activeClass);
    updateGrid(label.attr('data-sort-option'));
  }

  function createListElement(self) {
    var li = document.createElement('li');
    li.setAttribute('data-id', 'selected-sort');
    li.setAttribute('data-sort-by', true);
    li.innerHTML = self.text();	
    var removeIcon = document.createElement("div");
    removeIcon.className = "remove-icon";
    removeIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M0.901769 0.458065C0.67065 0.690323 0.487114 0.903226 0.500709 0.935484C0.514305 0.96129 1.42518 1.87742 2.5264 2.96774C3.62761 4.05806 4.53849 4.96774 4.55209 4.99355C4.55889 5.01935 3.68879 5.90323 2.61477 6.96774C1.53395 8.02581 0.616269 8.94839 0.561888 9.01935C0.480317 9.13548 0.507507 9.18065 0.922162 9.56774L1.3708 10L1.71748 9.67742C1.90782 9.49677 2.83229 8.59355 3.77036 7.65806L5.47656 5.96129L6.8021 7.27097C7.52944 7.99355 8.46072 8.89677 8.86177 9.29032L9.58912 10L10.0378 9.58065C10.2825 9.35484 10.4796 9.14194 10.4796 9.10968C10.4796 9.05806 10.0038 8.58065 7.6382 6.23871L6.38744 5L7.66539 3.72258C8.36555 3.02581 9.29002 2.11613 9.71827 1.69677L10.5 0.948387L10.2893 0.696774C10.1805 0.561291 9.96979 0.348388 9.83383 0.225806L9.58912 0L9.16767 0.419355C8.93655 0.651613 8.01207 1.55484 7.12159 2.43871L5.49016 4.03871L5.0891 3.66452C4.87158 3.45806 3.9539 2.55484 3.05661 1.65806C2.15253 0.767742 1.3912 0.032258 1.36401 0.032258C1.34361 0.032258 1.13289 0.225806 0.901769 0.458065Z" fill="black"/>
    </svg>`;
    li.appendChild(removeIcon);
    window.oaShopFilter.appendListItemToList(li);	
  }	

  function resetSortFilter() {
    uncheckLabels();
    if (window.oaShopFilter.isFilterListEmpty() && window.oaShopFilter.isPriceFilterSet != undefined && !window.oaShopFilter.isPriceFilterSet()) {
      $('.oa-shop-selected-filters-container').addClass('hidden');
      if (window.oaShopFilter.isCategoryInFilter(window.oaShopFilter.getFilter()[0])) {
        $('.oa-shop-filter [data-all="all"]').addClass('checked');
      }
    }

    checkPopularSort();
  }

  function initCheckboxes() {
    $('.oa-sort-container label[data-sort-option]').on('click', function(event) {
      event.preventDefault();
      var self = $(this);
      var elPopular = self.parent().children().first();
      var text = self.text();
      var labelLi = document.querySelectorAll(".oa-shop-filter__list li[data-sort-by]");
      var filterContainer = $('.oa-shop-selected-filters-container');
      if (labelLi) {
        labelLi.forEach(function(item) {
          item.remove();
        });
      }

      if (text !== elPopular.text()) {
        createListElement(self);
      } else {
        if (window.oaShopFilter.isFilterListEmpty() && window.oaShopFilter.isPriceFilterSet != undefined && !window.oaShopFilter.isPriceFilterSet()) {
          filterContainer.addClass('hidden');
          if (window.oaShopFilter.isCategoryInFilter(window.oaShopFilter.getFilter()[0])) {
            $('.oa-shop-filter [data-all="all"]').addClass('checked');
          }
        }
        uncheckLabels();
        checkLabel(self.parent().children().first());
      }

      window.oaShopFilter.updateOptionsCount();

      if (self.hasClass(activeClass)) {
        //uncheckLabel(self);
        updateGrid({
          sortBy: 'order'
        });
      } else {
        uncheckLabels();
        checkLabel(self);
      }
    });
  }

  function initDropdown() {
    $('.desktop-sort-by-dropdown [data-sort-option]').on('click', function(event) {
      event.preventDefault();
      uncheckLabels();
      checkLabel($(this));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCheckboxes();
    initDropdown();
  }, false);

  return {
    resetSortFilter: resetSortFilter
  };
})();

window.oaShopGridToggle = (function () {
  var domain = window.location.hostname.replace(/^[^.]+/g, '');

  var selectorDefault = '.grid-toggle-default',
      selectorFull = '.grid-toggle-full',
      classActive = 'grid-box-button--active',
      classGridFull = 'oa-shop-grid--full';

  var elDefault,
      elFull,
      elShopGrid;

  function onToggle(type, event) {
    if (event) {
      event.preventDefault();
    }
    if (!elShopGrid) {
      elShopGrid = document.querySelector('.oa-shop-grid');
    }
    if (!elShopGrid) return;

    elDefault.forEach(function(btn) {
      btn.classList[type === 'default' ? 'add' : 'remove'](classActive);
    });
    elFull.forEach(function(btn) {
      btn.classList[type === 'full' ? 'add' : 'remove'](classActive);
    });

    if (type === 'default') {
      elShopGrid.classList.remove(classGridFull);
    } else if (type === 'full') {
      elShopGrid.classList.add(classGridFull);
    }

    Cookies.set('oa_grid_layout', type, {expires: 30, path: '/', domain: domain});
  }

  document.addEventListener('DOMContentLoaded', function () {
    elDefault = document.querySelectorAll(selectorDefault);
    elFull = document.querySelectorAll(selectorFull);

    if (!elDefault || !elFull) { return; }

    elDefault.forEach(function(item) {
      item.addEventListener('click', onToggle.bind(item, 'default'));
    });
    elFull.forEach(function(item) {
      item.addEventListener('click', onToggle.bind(item, 'full'));
    });

    var type = Cookies.get('oa_grid_layout', {domain: domain});
    if (type && type !== 'default') {
      //onToggle(type, null);
    }
  }, false);

  return {

  };

})();

function applyFilterSelection() {
  window.oaHeaderSidenav.hide();
  $('.oa-header__sidenav__main').css('display', 'block');
  $('html').removeClass('oa-filtermobile--opened oa-sortmobile--opened');
  $('.oa-header__sidenav').removeClass('oa-header__sidenav--open');
  $('#oa-filter-sidebar').removeClass('visibleside');
  $('#oa-sort-sidebar').removeClass('visibleside');
}

document.addEventListener('DOMContentLoaded', function() {
  window.oaStickySidebar.setup();

  $('#side-filter-toggle').click(function() {
    window.oaHeaderSidenav.show();
    $('html').toggleClass('oa-filtermobile--opened');
    $('.oa-header__sidenav__main').css('display', 'none');
    $('.oa-header__sidenav').addClass('oa-header__sidenav--open');

  });

  $('.side-sort-toggle').click(function() {
    window.oaHeaderSidenav.show();
    $('html').toggleClass('oa-sortmobile--opened');

    $('.oa-header__sidenav__main').css('display', 'none');
    $('.oa-header__sidenav').addClass('oa-header__sidenav--open');
  });

  $('.oa-bckdrp19').click(function() {
    $('.oa-header__sidenav__main').css('display', 'block');
    $('html').removeClass('oa-filtermobile--opened');
    $('html').removeClass('oa-sortmobile--opened');
    $('.oa-header__sidenav').removeClass('oa-header__sidenav--open');
    $('#oa-filter-sidebar').removeClass('visibleside');
  });
});

(function () {
  var timeout;

  function resetTimeout() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  }

  function mouseenter (el) {
    if (!$(el).hasClass('active')) {
      return; 
    }
    resetTimeout();
  }

  function mouseleave(el, selected) { // ToDo
    if (!$(el).hasClass('active')) {
      return; 
    }
    if(!timeout) {
      timeout = setTimeout(function(){ 
        $('.oa-shop-filter--desktop ' + selected).toggle();
        $(el).toggleClass('active'); 
        $(el).parent().toggleClass('active'); 
        resetTimeout(el);
      }, 500);
    }
  }
  window.oa_open_filter_mob = function () {
    window.oaHeaderSidenav.show();
    $('html').toggleClass('oa-filtermobile--opened');
    $('.oa-header__sidenav__main').css('display', 'none');
    $('.oa-header__sidenav').addClass('oa-header__sidenav--open');

    $('#oa-filter-sidebar').addClass('visibleside');
    $('#headertoggle').removeClass('oa-hdr19-top__toggle--toggled');
    // if (! $('#oa-shop-filter__fashion-size-in').hasClass('active')) {
    //   $('#oa-shop-filter__fashion-size-in').trigger('click')
    // }
    // if (! $('#oa-shop-filter__fashion-activity-in').hasClass('active')) {
      // $('#oa-shop-filter__fashion-activity-in').trigger('click')
    // }
  }
  window.oa_open_sort_mob = function () {
    console.log("oa_open_sort_mob");
    $('.oa-filter-sidebar-wrapper').show()
    // $('#oa-filter-sidebar').show();
    setTimeout(function(){
      $('#headertoggle').removeClass('oa-hdr19-top__toggle--toggled');
    }, 50);
  }

  // window.clickFilter = function(selected, el) {
  // //  console.log("-------",selected)
  //   var isDesktop = $(el).parents('.oa-shop-filter--desktop').length == 1;
  //   var h = $('.oa-shop-collection-box .oa-shop-filter .oa-shop-filter__sub-heading');
  //  // console.log("--h.length-----",h.length)
  //   if (!h.length) {
  //     return;
  //   }
  //   resetTimeout();

  //   $((isDesktop ? '.oa-shop-filter--desktop ' : '.oa-header__sidenav ') + selected).toggle();
  //   $(el).toggleClass('active');
  //   $(el).parent().toggleClass('active');
  // }
  var oaShopFilterAnimating = false;
  window.clickFilter = function (selected, el) {
    if (oaShopFilterAnimating) return;
    oaShopFilterAnimating = true;
    var isDesktop = $(el).parents('.oa-shop-filter--desktop').length == 1;
    var h = $('.oa-shop-collection-box .oa-shop-filter .oa-shop-filter__sub-heading');
    var filterSelector = (isDesktop ? '.oa-shop-filter--desktop ' : '.oa-header__sidenav ') + selected;
    var $filter = $(filterSelector);

    resetTimeout();

    if (isVersionA(el)) {
      oaShopFilterAnimating = false;
      $((isDesktop ? '.oa-shop-filter--desktop ' : '.oa-header__sidenav ') + selected).toggle();
      $(el).toggleClass('active');
      $(el).parent().toggleClass('active');

      if (isDesktop) {
        h.each(function() {
          if(el == this) {return;}
          if($(this).hasClass('active')){
            $(this).next().toggle();
            $(this).toggleClass('active'); 
            $(this).parent().toggleClass('active'); 
          }
        });

        var wrapper = $(el).parent().first();
        if (wrapper.data('has-listener')) {
          return; 
        }
        wrapper.data('has-listener', true);

        var me = mouseenter.bind(null, el);
        var ml = mouseleave.bind(null, el, selected);

        $(el).mouseenter(me);
        $(el).mouseleave(ml);
        $(selected).mouseenter(me);
        $(selected).mouseleave(ml);
      }

    } else {
      resetTimeout();
      if ($filter.is(':visible')) {
        gsap.to($filter[0], {
          duration: 0.2,
          height: 0,
          overflow: 'hidden',
          ease: 'power2.inOut',
          onComplete: function () {
            $filter.hide();
            $filter.css('height', ''); // reset height
            oaShopFilterAnimating = false;
          }
        });
      } else {
        $filter.show();
        var fullHeight = $filter[0].scrollHeight;
        $filter.css({ height: 0, overflow: 'hidden' });
        gsap.to($filter[0], {
          duration: 0.2,
          height: fullHeight,
          overflow: 'hidden',
          ease: 'power2.inOut',
          onComplete: function () {
            $filter.css({ height: '', overflow: '' }); // reset after animation
            oaShopFilterAnimating = false;
          }
        });
      }

      $(el).toggleClass('active');
      $(el).parent().toggleClass('active');
    }
  };
})();

// TODO: Achtung, wenn man mit geöffneter Device Toolbar testet, dann wird isMobile immer true
$( document ).ready(function() {
  if(isMobile()) {
    // $('.oa-shop-filter__sub-heading').addClass('active');
    // $('.oa-shop-filter__sub-heading').next().css('display', 'block');
  } 
});





document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('#oa-shop-filter__main');
  const elBtn = el.querySelector('.sort-filter-box .btn-trigger-filter-mobile');
  function handleScroll () {
   
    if (window.outerWidth >= 1370) {
      return;
    }
   
    elBtn.classList.toggle('hidden', window.scrollY <= el.getBoundingClientRect().bottom+206);
  }
  window.addEventListener('scroll', throttle(100, handleScroll), { passive: true });
  handleScroll();
});
